import { render, staticRenderFns } from "./menu-confirmation.vue?vue&type=template&id=facc4eac&"
import script from "./menu-confirmation.vue?vue&type=script&lang=js&"
export * from "./menu-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports